import { lazyRoute } from "@/routes/lazy-route";

const PrintDashboard = lazyRoute(() => import("@/domain/public-dashboard/routes/print/print-dashboard.page"), "PrintDashboardPage");

export const printRoutes = [
  {
    path: "/print/dashboard/:dashboardId",
    element: <PrintDashboard />,
  },
];
